module.exports = __webpack_public_path__ + "static/media/yellow.18797685.png";